import * as Yup from 'yup';

export const customerSchema = Yup.object().shape({
  customerType: Yup.string().required('Customer type is required'),
  primaryContact: Yup.string().required('Primary contact is required'),
  companyName: Yup.string().when('customerType', {
    is: 'business',
    then: (schema) => schema.required('Company name is required'),
  }),
  email: Yup.string().email('Invalid email format'),
  phone: Yup.string(),
  gstTreatment: Yup.object().shape({
    gstNumber: Yup.string().when('gstType', {
      is: 'registered',
      then: (schema) => schema.required('GST number is required'),
    }),
  }),
});
